import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MenuItemService } from 'src/app/services/menu.item.service';
import { MessagesService } from 'src/app/services/messages.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import { ClothesService } from 'src/app/services/clothes.service';
import { OrderService } from 'src/app/services/order.service';

declare var jQuery: any;

@Component({
  selector: 'app-menu-admin',
  templateUrl: './menu-admin.component.html',
  styleUrls: ['./menu-admin.component.scss']
})
export class MenuAdminComponent implements OnInit {

  public user: string;
  public role: string;
  public numberRole: number;
  public mensajesNoLeidos: string;
  public activeUser: string;
  public forcedChangePassword: string;
  public navImage = CONSTANTES.navBarImage;
  public menuImage = CONSTANTES.menuImage;
  public menuItems: string[] = [];
  public infoStock: number;
  public infoOrderPending: number;

  constructor(private menuItemService: MenuItemService, private mensajesService: MessagesService, private router: Router,
    private authService: AuthenticationService, private clothesService: ClothesService, private orderService: OrderService) { }

  pdfSrc="http://localhost/pcami/pdf/MANUAL_DE_USUARIO_"+localStorage.getItem("role")+".pdf"

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);

    this.user = localStorage.getItem("nid");
    this.numberRole = +localStorage.getItem("numberRole");
    this.role = localStorage.getItem("role");
    this.checkUserActive();
    this.getMenuItems();
    
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  checkUserActive() {
    this.activeUser = localStorage.getItem("active");
  }

  checkForcedChangePassword() {
    this.forcedChangePassword = localStorage.getItem("forcedChangePassword");
  }
  
  getMenuItems(){
    this.menuItemService.getMenuItemsByUser(this.user, this.role).subscribe(
      data => {
        if (getToken(data)) {
          data.menus.forEach(element => {
            this.menuItems.push(element.id.toString());
          });
          this.getInfoStock(); 
        } else {
          this.logOut();
        }
      },
      error => {
        this.logOut();
      }
    )
  }

  getInfoStock(){
    this.clothesService.getStockOut().subscribe(
      data => {
        if (getToken(data)) {
          this.infoStock = data.stockOut;
        }
        this.getInfoOrderPending();
      }, error => {
        this.logOut();
      }
    );
  }

  getInfoOrderPending(){
    this.orderService.getOrderPending().subscribe(
      data => {
        if (getToken(data)) {
          this.infoOrderPending = data.orderPending;
        }
      }, error => {
        this.logOut();
      }
    );
  }

}
